const initialState = {
	wxList: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case "SET_WXLIST":
			return {
				...state,
				wxList: action.payload,
			};
		default:
			return state;
	}
}
